import QuestionnaireApprovalItem from './QuestionnaireApprovalItem'

export default QuestionnaireApprovalItem
